import { AlertDialog, AlertDialogHeader, AlertDialogOverlay, AlertDialogContent, AlertDialogBody, AlertDialogFooter, Button, HStack, Box } from "@chakra-ui/react";
import { DangerIcon } from "lib/icons/danger";
import { FC, useRef } from "react";
import { isSharedPack } from "domains/packs/utils";
import { useActivePackContext } from "lib/context";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

export const DeletePackAlertDialog: FC<Props> = ({ onClose, isOpen, onDelete }) => {
  const cancelRef = useRef();
  const { activePack } = useActivePackContext();

  const isShared = activePack?.id ? isSharedPack(activePack.id) : false;

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>
          <HStack spacing="20px">
            <Box width="32px">
              <DangerIcon width="32px" height="32px"/>
            </Box>
            <Box>
              Are you sure you want to {isShared ? 'remove' : 'delete'} this pack?
            </Box>
          </HStack>
        </AlertDialogHeader>
        <AlertDialogBody>
          {isShared
            ? <>This will remove the shared pack from your account only.</>
            : <>This will permanently delete this pack and all of its assets for you and anybody you shared this pack with. This action cannot be undone.</>
          }
        </AlertDialogBody>
        <AlertDialogFooter>
          <HStack spacing="20px">
            <Button variant="cancel" ref={cancelRef} onClick={onClose}>Cancel</Button>
            <Button variant="destructive" onClick={onDelete}>{isShared ? 'Remove' : 'Delete'}</Button>
          </HStack>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
